import React from 'react'
import { Link as LinkButton, Paragraph } from '@pandiafi/design-system'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Bulletins } from '../../../../../common/validations'

import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'
import { BulletinFeaturedImage } from 'components/Bulletin/components/BulletinFeaturedImage/BulletinFeaturedImage'
import { BulletinTitle } from 'components/Bulletin/components/BulletinTitle/BulletinTitle'
import { BulletinDetails } from 'components/Bulletin/components/BulletinDetails/BulletinDetails'
import { BulletinWrapper } from 'components/Bulletin/components/BulletinWrapper/BulletinWrapper'

interface BulletinListItemProps {
  bulletin: Bulletins[number]
  lastBulletin?: boolean
}

export const BulletinListItem: React.FC<BulletinListItemProps> = ({
  bulletin: {
    uuid,
    title,
    publishedAt,
    updatedAt,
    author,
    excerpt,
    featuredImage,
  },
  lastBulletin,
}) => {
  const [t] = useTranslation(['frontPage'])
  const { bulletinPath } = useContractPaths()
  const navigate = useNavigate()
  const link = bulletinPath.replace(':bulletinUuid', uuid)

  return (
    <BulletinWrapper
      className={`pb-8 ${lastBulletin ? '' : 'border-b border-b-common-gray-4'}`}
    >
      <Link to={link}>
        <BulletinTitle title={title} />
      </Link>

      <BulletinDetails
        publishedAt={publishedAt}
        updatedAt={updatedAt}
        author={author}
      />

      {featuredImage && <BulletinFeaturedImage featuredImage={featuredImage} />}

      <Paragraph>
        {excerpt.split('\n').map((line, idx, arr) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <React.Fragment key={`line-${idx}`}>
            {line}
            {idx < arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Paragraph>

      <LinkButton
        onPress={() => navigate(link)}
        to={link}
        variant="button"
        secondary
        className="self-end mt-3"
      >
        {t('frontPage:buttons.readBulletin')}
      </LinkButton>
    </BulletinWrapper>
  )
}
